// 메뉴 카테고리별 라우트 정의 (상수)
export const MENU_ROUTES = {
  settings: [
    '/blockchain_network',
    '/api-keys',
    '/user_registration',
    '/system_wallet',
    '/preferences',
    '/two_factor',
    '/security_keys',
    '/session_management',
    '/health_check',
    '/notification_preferences',
    '/contract_deploy',
    '/deploy_history',
  ],
  // Admin 전용 라우트 (역할 기반 접근)
  adminSettings: [
    '/role_management',
    '/permission_management',
    '/audit_log',
    '/login_history',
    '/threshold_settings',
    '/ip_whitelist',
    '/api_stats',
    '/multisig_settings',
    '/wallet_monitor',
    '/anomaly_detection',
    '/backup_monitor',
    '/price_alerts',
    '/scheduled_reports',
    '/ai_agent',
  ],
  erc20: [
    '/dashboard',
    '/holders_erc20',
    '/transaction_erc20',
    '/transfers_erc20',
    '/manual_transfer_request',
    '/manual_transfer_processing',
    '/manual_transfer_history',
    '/withdrawal_request',
    '/withdrawal_history',
    '/pending_withrawal',
    '/rejection_history',
    '/withdrawal_restriction',
    '/skyplay_wallet',
    '/skyplay_deposit_list',
    '/lockup_schedules',
    '/holder_analysis',
    '/cross_network',
    '/holder_tracking',
    '/withdraw_stats',
  ],
  erc721: [
    '/transaction_erc721',
    '/transfers_erc721',
    '/holders_erc721',
    '/inventory_erc721',
    '/minting_request_nft721',
    '/minting_process_nft721',
    '/minting_history_nft721',
  ],
  erc1155: [
    '/transaction_erc1155',
    '/transfers_erc1155',
    '/holders_erc1155',
    '/inventory_erc1155',
    '/metadata_erc1155',
    '/minting_request_nft1155',
    '/minting_process_nft1155',
  ],
  board: [
    '/metaplanet_board',
    '/metaplanet_mintit',
    '/newsroom',
    '/notice_list',
    '/file_list',
  ],
  arena: ['/arena_mission', '/arena_tokens', '/arena_tokens_history'],
  logData: [
    '/metaplanet_LtbDeposit',
    '/metaplanet_LtbSwap',
    '/metaplanet_LtbTransferMetaq',
    '/metaplanet_LtbWithdraw',
    '/metaplanet_LtbMetaq',
    '/metaplanet_LtbNftStaking',
    '/metaplanet_LtbTokens',
    '/metaplanet_LtbTransferNft',
  ],
  metaqData: [
    '/metaplanet_token',
    '/metaplanet_oldtoken',
    '/metaplanet_presale',
    '/metaplanet_coinsale',
    '/metaplanet_lbank',
    '/lbank_monitor',
    '/lbank_schedule',
    '/lbank_reports',
    '/gas_analysis',
    '/trade_alert_settings',
  ],
}

// 카테고리별 Set 생성 (O(1) 조회용)
export const MENU_ROUTE_SETS = Object.fromEntries(
  Object.entries(MENU_ROUTES).map(([key, routes]) => [key, new Set(routes)])
)

// 전체 메뉴 항목 정의
export const MENU_ITEMS = [
  {
    text: 'menu.blockchainNetwork',
    route: '/blockchain_network',
    icon: 'mdi-lan-connect',
    description: 'menuDesc.blockchainNetwork',
    enabled: false,
  },
  {
    text: 'menu.apiKeys',
    route: '/api-keys',
    icon: 'mdi-key',
    description: 'menuDesc.apiKeys',
    enabled: false,
  },
  {
    text: 'menu.userRegistration',
    route: '/user_registration',
    icon: 'mdi-account-check',
    description: 'menuDesc.userRegistration',
    enabled: false,
  },
  {
    text: 'menu.systemWallet',
    route: '/system_wallet',
    icon: 'mdi-wallet-outline',
    description: 'menuDesc.systemWallet',
    enabled: false,
  },
  {
    text: 'menu.roleManagement',
    route: '/role_management',
    icon: 'mdi-account-group',
    description: 'menuDesc.roleManagement',
    enabled: false,
  },
  {
    text: 'menu.permissionManagement',
    route: '/permission_management',
    icon: 'mdi-shield-key',
    description: 'menuDesc.permissionManagement',
    enabled: false,
  },
  {
    text: 'menu.auditLog',
    route: '/audit_log',
    icon: 'mdi-history',
    description: 'menuDesc.auditLog',
    enabled: false,
  },
  {
    text: 'menu.loginHistory',
    route: '/login_history',
    icon: 'mdi-login',
    description: 'menuDesc.loginHistory',
    enabled: false,
  },
  {
    text: 'menu.thresholdSettings',
    route: '/threshold_settings',
    icon: 'mdi-gauge',
    description: 'menuDesc.thresholdSettings',
    enabled: false,
  },
  {
    text: 'menu.twoFactorAuth',
    route: '/two_factor',
    icon: 'mdi-shield-lock',
    description: 'menuDesc.twoFactorAuth',
    enabled: false,
  },
  {
    text: 'menu.securityKeys',
    route: '/security_keys',
    icon: 'mdi-key-variant',
    description: 'menuDesc.securityKeys',
    enabled: false,
  },
  {
    text: 'menu.sessionManagement',
    route: '/session_management',
    icon: 'mdi-devices',
    description: 'menuDesc.sessionManagement',
    enabled: false,
  },
  {
    text: 'menu.ipWhitelist',
    route: '/ip_whitelist',
    icon: 'mdi-shield-check',
    description: 'menuDesc.ipWhitelist',
    enabled: false,
  },
  {
    text: 'menu.preferences',
    route: '/preferences',
    icon: 'mdi-cog-outline',
    description: 'menuDesc.preferences',
    enabled: false,
  },
  {
    text: 'menu.dashboard',
    route: '/dashboard',
    icon: 'mdi-view-dashboard',
    description: 'menuDesc.dashboard',
    enabled: false,
  },
  {
    text: 'menu.holdersErc20',
    route: '/holders_erc20',
    icon: 'mdi-account-outline',
    description: 'menuDesc.holdersErc20',
    enabled: false,
  },
  {
    text: 'menu.lockupSchedules',
    route: '/lockup_schedules',
    icon: 'mdi-account-outline',
    description: 'menuDesc.lockupSchedules',
    enabled: false,
  },
  {
    text: 'menu.holderAnalysis',
    route: '/holder_analysis',
    icon: 'mdi-chart-pie',
    description: 'menuDesc.holderAnalysis',
    enabled: false,
  },
  {
    text: 'menu.crossNetwork',
    route: '/cross_network',
    icon: 'mdi-swap-horizontal-bold',
    description: 'menuDesc.crossNetwork',
    enabled: false,
  },
  {
    text: 'menu.holderTracking',
    route: '/holder_tracking',
    icon: 'mdi-chart-timeline-variant-shimmer',
    description: 'menuDesc.holderTracking',
    enabled: false,
  },
  {
    text: 'menu.transfersErc20',
    route: '/transfers_erc20',
    icon: 'mdi-truck-delivery-outline',
    description: 'menuDesc.transfersErc20',
    enabled: false,
  },
  {
    text: 'menu.transactionErc20',
    route: '/transaction_erc20',
    icon: 'mdi-tag-check-outline',
    description: 'menuDesc.transactionErc20',
    enabled: false,
  },
  {
    text: 'menu.manualTransferRequest',
    route: '/manual_transfer_request',
    icon: 'mdi-note-edit-outline',
    description: 'menuDesc.manualTransferRequest',
    enabled: false,
  },
  {
    text: 'menu.manualTransferProcessing',
    route: '/manual_transfer_processing',
    icon: 'mdi-ticket-confirmation-outline',
    description: 'menuDesc.manualTransferProcessing',
    enabled: false,
  },
  {
    text: 'menu.manualTransferHistory',
    route: '/manual_transfer_history',
    icon: 'mdi-clipboard-text-clock-outline',
    description: 'menuDesc.manualTransferHistory',
    enabled: false,
  },
  {
    text: 'menu.withdrawalRequest',
    route: '/withdrawal_request',
    icon: 'mdi-ticket-confirmation-outline',
    description: 'menuDesc.withdrawalRequest',
    enabled: false,
  },
  {
    text: 'menu.withdrawalHistory',
    route: '/withdrawal_history',
    icon: 'mdi-clipboard-text-clock-outline',
    description: 'menuDesc.withdrawalHistory',
    enabled: false,
  },
  {
    text: 'menu.pendingWithrawal',
    route: '/pending_withrawal',
    icon: 'mdi-link-lock',
    description: 'menuDesc.pendingWithrawal',
    enabled: false,
  },
  {
    text: 'menu.transactionStatus',
    route: '/transaction_status',
    icon: 'mdi-truck-check-outline',
    description: 'menuDesc.transactionStatus',
    enabled: false,
  },
  {
    text: 'menu.withdrawalRestriction',
    route: '/withdrawal_restriction',
    icon: 'mdi-account-cancel',
    description: 'menuDesc.withdrawalRestriction',
    enabled: false,
  },
  {
    text: 'menu.rejectionHistory',
    route: '/rejection_history',
    icon: 'mdi-undo-variant',
    description: 'menuDesc.rejectionHistory',
    enabled: false,
  },
  {
    text: 'menu.platformWallet',
    route: '/skyplay_wallet',
    icon: 'mdi-wallet-outline',
    description: 'menuDesc.platformWallet',
    enabled: false,
  },
  {
    text: 'menu.platformDepositList',
    route: '/skyplay_deposit_list',
    icon: 'mdi-wallet-plus-outline',
    description: 'menuDesc.platformDepositList',
    enabled: false,
  },
  {
    text: 'menu.inventoryErc721',
    route: '/inventory_erc721',
    icon: 'mdi-format-list-bulleted',
    description: 'menuDesc.inventoryErc721',
    enabled: false,
  },
  {
    text: 'menu.holdersErc721',
    route: '/holders_erc721',
    icon: 'mdi-account-outline',
    description: 'menuDesc.holdersErc721',
    enabled: false,
  },
  {
    text: 'menu.transfersErc721',
    route: '/transfers_erc721',
    icon: 'mdi-truck-delivery-outline',
    description: 'menuDesc.transfersErc721',
    enabled: false,
  },
  {
    text: 'menu.transactionErc721',
    route: '/transaction_erc721',
    icon: 'mdi-tag-check-outline',
    description: 'menuDesc.transactionErc721',
    enabled: false,
  },
  {
    text: 'menu.mintingRequestNft721',
    route: '/minting_request_nft721',
    icon: 'mdi-note-edit-outline',
    description: 'menuDesc.mintingRequestNft721',
    enabled: false,
  },
  {
    text: 'menu.mintingProcessNft721',
    route: '/minting_process_nft721',
    icon: 'mdi-ticket-confirmation-outline',
    description: 'menuDesc.mintingProcessNft721',
    enabled: false,
  },
  {
    text: 'menu.mintingHistoryNft721',
    route: '/minting_history_nft721',
    icon: 'mdi-ticket-confirmation-outline',
    description: 'menuDesc.mintingHistoryNft721',
    enabled: false,
  },
  {
    text: 'menu.inventoryErc1155',
    route: '/inventory_erc1155',
    icon: 'mdi-format-list-bulleted',
    description: 'menuDesc.inventoryErc1155',
    enabled: false,
  },
  {
    text: 'menu.holdersErc1155',
    route: '/holders_erc1155',
    icon: 'mdi-account-outline',
    description: 'menuDesc.holdersErc1155',
    enabled: false,
  },
  {
    text: 'menu.transfersErc1155',
    route: '/transfers_erc1155',
    icon: 'mdi-truck-delivery-outline',
    description: 'menuDesc.transfersErc1155',
    enabled: false,
  },
  {
    text: 'menu.transactionErc1155',
    route: '/transaction_erc1155',
    icon: 'mdi-tag-check-outline',
    description: 'menuDesc.transactionErc1155',
    enabled: false,
  },
  {
    text: 'menu.mintingRequestNft1155',
    route: '/minting_request_nft1155',
    icon: 'mdi-note-edit-outline',
    description: 'menuDesc.mintingRequestNft1155',
    enabled: false,
  },
  {
    text: 'menu.mintingProcessNft1155',
    route: '/minting_process_nft1155',
    icon: 'mdi-ticket-confirmation-outline',
    description: 'menuDesc.mintingProcessNft1155',
    enabled: false,
  },
  {
    text: 'menu.fileList',
    route: '/file_list',
    icon: 'mdi-file-cabinet',
    description: 'menuDesc.fileList',
    enabled: false,
  },
  {
    text: 'menu.arenaMission',
    route: '/arena_mission',
    icon: 'mdi-newspaper-variant-outline',
    description: 'menuDesc.arenaMission',
    enabled: false,
  },
  {
    text: 'menu.arenaTokens',
    route: '/arena_tokens',
    icon: 'mdi-newspaper-variant-outline',
    description: 'menuDesc.arenaTokens',
    enabled: false,
  },
  {
    text: 'menu.arenaTokensHistory',
    route: '/arena_tokens_history',
    icon: 'mdi-newspaper-variant-outline',
    description: 'menuDesc.arenaTokensHistory',
    enabled: false,
  },
  {
    text: 'menu.portalBoard',
    route: '/metaplanet_board',
    icon: 'mdi-newspaper-variant-outline',
    description: 'menuDesc.portalBoard',
    enabled: false,
  },
  {
    text: 'menu.portalLbank',
    route: '/metaplanet_lbank',
    icon: 'mdi-chart-line',
    description: 'menuDesc.portalLbank',
    enabled: false,
  },
  {
    text: 'menu.lbankMonitor',
    route: '/lbank_monitor',
    icon: 'mdi-monitor-dashboard',
    description: 'menuDesc.lbankMonitor',
    enabled: false,
  },
  {
    text: 'menu.lbankSchedule',
    route: '/lbank_schedule',
    icon: 'mdi-calendar-clock',
    description: 'menuDesc.lbankSchedule',
    enabled: false,
  },
  {
    text: 'menu.lbankReports',
    route: '/lbank_reports',
    icon: 'mdi-file-chart',
    description: 'menuDesc.lbankReports',
    enabled: false,
  },
  {
    text: 'menu.gasAnalysis',
    route: '/gas_analysis',
    icon: 'mdi-gas-station',
    description: 'menuDesc.gasAnalysis',
    enabled: false,
  },
  {
    text: 'menu.tradeAlertSettings',
    route: '/trade_alert_settings',
    icon: 'mdi-bell-alert-outline',
    description: 'menuDesc.tradeAlertSettings',
    enabled: false,
  },
  {
    text: 'menu.portalPresale',
    route: '/metaplanet_presale',
    icon: 'mdi-newspaper-variant-outline',
    description: 'menuDesc.portalPresale',
    enabled: false,
  },
  {
    text: 'menu.portalCoinsale',
    route: '/metaplanet_coinsale',
    icon: 'mdi-newspaper-variant-outline',
    description: 'menuDesc.portalCoinsale',
    enabled: false,
  },
  {
    text: 'menu.portalToken',
    route: '/metaplanet_token',
    icon: 'mdi-newspaper-variant-outline',
    description: 'menuDesc.portalToken',
    enabled: false,
  },
  {
    text: 'menu.portalOldtoken',
    route: '/metaplanet_oldtoken',
    icon: 'mdi-newspaper-variant-outline',
    description: 'menuDesc.portalOldtoken',
    enabled: false,
  },
  {
    text: 'menu.portalLtbDeposit',
    route: '/metaplanet_LtbDeposit',
    icon: 'mdi-history',
    description: 'menuDesc.portalLtbDeposit',
    enabled: false,
  },
  {
    text: 'menu.portalLtbSwap',
    route: '/metaplanet_LtbSwap',
    icon: 'mdi-history',
    description: 'menuDesc.portalLtbSwap',
    enabled: false,
  },
  {
    text: 'menu.portalLtbTransferMetaq',
    route: '/metaplanet_LtbTransferMetaq',
    icon: 'mdi-history',
    description: 'menuDesc.portalLtbTransferMetaq',
    enabled: false,
  },
  {
    text: 'menu.portalLtbWithdraw',
    route: '/metaplanet_LtbWithdraw',
    icon: 'mdi-history',
    description: 'menuDesc.portalLtbWithdraw',
    enabled: false,
  },
  {
    text: 'menu.portalLtbMetaq',
    route: '/metaplanet_LtbMetaq',
    icon: 'mdi-history',
    description: 'menuDesc.portalLtbMetaq',
    enabled: false,
  },
  {
    text: 'menu.portalLtbNftStaking',
    route: '/metaplanet_LtbNftStaking',
    icon: 'mdi-history',
    description: 'menuDesc.portalLtbNftStaking',
    enabled: false,
  },
  {
    text: 'menu.portalLtbTokens',
    route: '/metaplanet_LtbTokens',
    icon: 'mdi-history',
    description: 'menuDesc.portalLtbTokens',
    enabled: false,
  },
  {
    text: 'menu.portalLtbTransferNft',
    route: '/metaplanet_LtbTransferNft',
    icon: 'mdi-history',
    description: 'menuDesc.portalLtbTransferNft',
    enabled: false,
  },
  {
    text: 'menu.portalMintit',
    route: '/metaplanet_mintit',
    icon: 'mdi-newspaper-variant-outline',
    description: 'menuDesc.portalMintit',
    enabled: false,
  },
  {
    text: 'menu.newsroom',
    route: '/newsroom',
    icon: 'mdi-newspaper-variant-outline',
    description: 'menuDesc.newsroom',
    enabled: false,
  },
  {
    text: 'menu.noticeList',
    route: '/notice_list',
    icon: 'mdi-bulletin-board',
    description: 'menuDesc.noticeList',
    enabled: false,
  },
  {
    text: 'menu.mcpIssueTransaction',
    route: '/mcp_issue_transaction',
    icon: 'mdi-home',
    description: 'menuDesc.mcpIssueTransaction',
    enabled: false,
  },
  {
    text: 'menu.mcpWaitingApproval',
    route: '/mcp_waiting_approval',
    icon: 'mdi-checkbox-multiple-marked',
    description: 'menuDesc.mcpWaitingApproval',
    enabled: false,
  },
  {
    text: 'menu.mcpTransferHistory',
    route: '/mcp_transfer_history',
    icon: 'mdi-database-clock',
    description: 'menuDesc.mcpTransferHistory',
    enabled: false,
  },
  {
    text: 'menu.mcpCreateWallet',
    route: '/mcp_create_wallet',
    icon: 'mdi-credit-card-plus',
    description: 'menuDesc.mcpCreateWallet',
    enabled: false,
  },
  {
    text: 'menu.mcpRegisterAddress',
    route: '/mcp_register_address',
    icon: 'mdi-account-plus',
    description: 'menuDesc.mcpRegisterAddress',
    enabled: false,
  },
  {
    text: 'menu.healthCheck',
    route: '/health_check',
    icon: 'mdi-heart-pulse',
    description: 'menuDesc.healthCheck',
    enabled: false,
  },
  {
    text: 'menu.notificationPreferences',
    route: '/notification_preferences',
    icon: 'mdi-bell-cog',
    description: 'menuDesc.notificationPreferences',
    enabled: false,
  },
  {
    text: 'menu.apiStats',
    route: '/api_stats',
    icon: 'mdi-chart-bar',
    description: 'menuDesc.apiStats',
    enabled: false,
  },
  {
    text: 'menu.multisigSettings',
    route: '/multisig_settings',
    icon: 'mdi-shield-key',
    description: 'menuDesc.multisigSettings',
    enabled: false,
  },
  {
    text: 'menu.withdrawStats',
    route: '/withdraw_stats',
    icon: 'mdi-chart-timeline-variant',
    description: 'menuDesc.withdrawStats',
    enabled: false,
  },
  {
    text: 'menu.contractDeploy',
    route: '/contract_deploy',
    icon: 'mdi-rocket-launch',
    description: 'menuDesc.contractDeploy',
    enabled: false,
  },
  {
    text: 'menu.deployHistory',
    route: '/deploy_history',
    icon: 'mdi-history',
    description: 'menuDesc.deployHistory',
    enabled: false,
  },
  {
    text: 'menu.walletMonitor',
    route: '/wallet_monitor',
    icon: 'mdi-wallet-bifold',
    description: 'menuDesc.walletMonitor',
    enabled: false,
  },
  {
    text: 'menu.anomalyDetection',
    route: '/anomaly_detection',
    icon: 'mdi-shield-alert',
    description: 'menuDesc.anomalyDetection',
    enabled: false,
  },
  {
    text: 'menu.backupMonitor',
    route: '/backup_monitor',
    icon: 'mdi-database-clock',
    description: 'menuDesc.backupMonitor',
    enabled: false,
  },
  {
    text: 'menu.priceAlerts',
    route: '/price_alerts',
    icon: 'mdi-bell-ring',
    description: 'menuDesc.priceAlerts',
    enabled: false,
  },
  {
    text: 'menu.scheduledReports',
    route: '/scheduled_reports',
    icon: 'mdi-calendar-clock',
    description: 'menuDesc.scheduledReports',
    enabled: false,
  },
  {
    text: 'menu.aiAgent',
    route: '/ai_agent',
    icon: 'mdi-robot-outline',
    description: 'menuDesc.aiAgent',
    enabled: false,
  },
]
